<template>
  <b-card class="mb-3" :class="'status-' + item.status">
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="3">
            <strong>Case #</strong>
          </b-col>
          <b-col>{{ item.id }}</b-col>
        </b-row>
      </b-col>
      <b-col></b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="3">
            <strong>Region</strong>
          </b-col>
          <b-col>{{ item.region }}</b-col>
        </b-row>

        <b-row>
          <b-col cols="3">
            <strong>Created By</strong>
          </b-col>
          <b-col>{{ item.created_by }}</b-col>
        </b-row>

        <b-row>
          <b-col cols="3">
            <strong>Order #</strong>
          </b-col>
          <b-col
            ><span class="tracking_url" @click="goToTrackingDetail(item)">{{
              item.tracking_number
            }}</span></b-col
          >
        </b-row>
      </b-col>

      <b-col>
        <b-row>
          <b-col cols="3">
            <strong>Category</strong>
          </b-col>
          <b-col>{{ item.category }}</b-col>
        </b-row>

        <b-row>
          <b-col cols="3">
            <strong>Created at</strong>
          </b-col>
          <b-col>{{ item.created_at }}</b-col>
        </b-row>

        <b-row>
          <b-col cols="3">
            <strong>Status</strong>
          </b-col>
          <b-col>
            <span
              v-if="
                !(
                  $store.state.user_obj.account_type == 'admin' ||
                  $store.state.user_obj.account_type == 'client_admin' || 
                  $store.state.user_obj.account_type == 'cs'
                )
              "
            >
              {{ item.status }}
              <br>
              <b-form-select
              v-if="item.status == 'Complete'"
              size="sm"
              v-model="item.acknowledged"
              :options="acknowledged_status_options"
              :disabled="item.acknowledged == 'YES'"
              @change="onChangeAcknowledged($event, item)"
            />
            </span>
            <b-form-select
              size="sm"
              v-model="item.status"
              :options="status_options"
              @change="onChangeCsStatus($event, item)"
              v-if="
                $store.state.user_obj.account_type == 'admin' ||
                $store.state.user_obj.account_type == 'client_admin' || 
                  $store.state.user_obj.account_type == 'cs'
              "
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-1" v-show="false">
      <b-col>
        <b-row>
          <b-col cols="2">
            <strong>Replacement Order#</strong>
          </b-col>
          <b-col cols="4">
            <span>
              <span v-if="item.status != 'Pending' && item.status != 'Cancel'">
                {{ item.delivery_cost }}
              </span>
              <b-form-input
                v-if="item.status == 'Pending' || item.status == 'Cancel'"
                id="input-small"
                size="sm"
                type="text"
                placeholder="..."
                v-model="item.replacement_order_number"
                @change="onUpdateReplacementOrder($event, item)"
              ></b-form-input>
              <b-button
                v-if="item.status == 'Pending' || item.status == 'Cancel'"
                style="float: right;"
                class="mt-1"
                type="button"
                size="sm"
                variant="primary"
                @click="onUpdateReplacementOrder()"
              >
                Submit
              </b-button>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-1" v-if="item.replacement_order_number">
      <b-col>
        <b-row>
          <b-col cols="2">
            <strong>Delivery Cost</strong>
          </b-col>
          <b-col cols="4">
            <span v-if="item.status != 'Pending' && item.status != 'Cancel'">
              {{ item.delivery_cost }}
            </span>

            <b-form-input
              id="input-small"
              size="sm"
              type="text"
              placeholder="..."
              v-model="item.delivery_cost"
              @change="onUpdateDeliveryCost($event, item)"
              v-if="item.status == 'Pending' || item.status == 'Cancel'"
            ></b-form-input>
            <b-button
              v-if="item.status == 'Pending' || item.status == 'Cancel'"
              style="float: right;"
              class="mt-1"
              type="button"
              size="sm"
              variant="primary"
              @click="onUpdateDeliveryCost()"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <div v-if="item.products && item.products.length > 0" class="mt-2">
      <b-table
        responsive
        small
        outlined
        striped
        hover
        :items="item.products"
        :fields="product_fields"
      >
      </b-table>
    </div>

    <!-- <div v-if="(item.products && item.products.length > 0)">
      <hr />
      <div class="rows_product">
        <div
          class="row_product"
          :key="'product_' + product_i"
          v-for="(product, product_i) in item.products"
        >
          <b-card>
            <div><strong>Product#</strong>: {{ product.product_number }}</div>
            <div><strong>Lot#</strong>: {{ product.lot_number }}</div>
            <div><strong>Quantity</strong>: {{ product.quantity }}</div>
          </b-card>
        </div>
      </div>
    </div> -->

    <!-- <hr /> -->
    <b-button
      type="button"
      size="sm"
      variant="primary"
      @click="onToggleContent()"
    >
      <span v-if="!isShowContent">Show Detail</span>
      <span v-if="isShowContent">Hide Detail</span>
    </b-button>
    <div v-if="isShowContent">
      <br />
      <div
        :key="'content' + content_i"
        v-for="(content, content_i) in item.contents"
      >
        {{ displayDate(content.created_at) }} -
        <strong class="user-gols" v-if="content.account_type != 'client_user'">[{{ content.created_by_name }}]</strong>:
        <strong class="user-client" v-if="content.account_type == 'client_user'">[{{ content.created_by_name }}]</strong>:
        {{ content.content }}
      </div>

      <div v-if="mode == 'edit'">
        <b-form-textarea
          class="mb-1 mt-1"
          id="txt_content"
          required
          placeholder="Type a message"
          rows="3"
          max-rows="6"
          v-model="item.reply_content"
        ></b-form-textarea>

        <b-button
          class="float-right"
          type="button"
          variant="primary"
          @click="replyCsIssue(item)"
          >Submit</b-button
        >
      </div>
    </div>
  </b-card>
</template>

<script>
import moment from "moment";

export default {
  name: "CsIssueCard",
  props: ["item", "mode"],
  inject: ["API_HOST"],
  components: {},
  data() {
    return {
      isShowContent: false,
      product_fields: [
        {
          key: "product_number",
          label: "Product#"
        },
        {
          key: "description",
          label: "Description"
        },
        {
          key: "lot_number",
          label: "Lot#"
        },
        {
          key: "price",
          label: "Price"
        },
        {
          key: "quantity",
          label: "Quantity"
        },
        {
          key: "total_amount",
          label: "Total Amount"
        }
      ],
      acknowledged_status_options: [
      {
          value: "NO",
          text: "Acknowledged : No"
        },
        {
          value: "YES",
          text: "Acknowledged : Yes"
        },
      ],
      status_options: [
        {
          value: "Pending",
          text: "Pending"
        },
        // {
        //   value: "Complete (N/A)",
        //   text: "Complete (N/A)"
        // },
        // {
        //   value: "Complete (Valid)",
        //   text: "Complete (Valid)"
        // },
        // {
        //   value: "Complete (Invalid)",
        //   text: "Complete (Invalid)"
        // },
        {
          value: "Complete",
          text: "Complete"
        },
        {
          value: "Cancel",
          text: "Cancel"
        }
      ]
    };
  },
  async created() {},
  mounted() {},
  methods: {
    onToggleContent() {
      this.isShowContent = !this.isShowContent;
    },
    async onChangeAcknowledged(event, item) {

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_update_acknowledged.php",
        data: {
          cs_issue_id: item.id,
          status: event,
          user_id: this.$store.state.user_obj.user_id
        }
      });
    },
    async onChangeCsStatus(event, item) {
      if (
        event == "Complete (N/A)" ||
        event == "Complete (Valid)" ||
        event == "Complete (Invalid)"
      ) {
        // check if replacement order, required delivery cost if so
        if (
          item.replacement_order_number &&
          item.replacement_order_number != ""
        ) {
          if (!item.delivery_cost || item.delivery_cost == "") {
            alert("Please enter delivery cost");
            setTimeout(() => {
              item.status = "Pending";
            }, 100);
            return;
          }
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_update_status.php",
        data: {
          cs_issue_id: item.id,
          status: event,
          user_id: this.$store.state.user_obj.user_id
        }
      });
    },

    async onUpdateReplacementOrder(event, item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_update_replacement_order.php",
        data: {
          cs_issue_id: item.id,
          replacement_order_number: item.replacement_order_number,
          user_id: this.$store.state.user_obj.user_id
        }
      });
    },

    async onUpdateDeliveryCost(event, item) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_update_delivery_cost.php",
        data: {
          cs_issue_id: item.id,
          delivery_cost: item.delivery_cost,
          user_id: this.$store.state.user_obj.user_id
        }
      });
    },

    async replyCsIssue(item) {
      if (!item.reply_content || item.reply_content == "") {
        return;
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_reply.php",
        data: {
          cs_issue_id: item.id,
          content: item.reply_content,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      window.location.reload();
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD HH:mm");
      } else {
        return "/";
      }
    },

    async getCsIssues() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "cs_issue_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria
        }
      });
      this.items = response.data.cs_issues;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    goToTrackingDetail(item) {
      this.$router.push({
        name: "tracking_detail",
        params: { id: item.tracking_id }
      });
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.tracking_url {
  cursor: pointer;
  text-decoration: underline;
}

.status-Complete {
  border-top: 5px solid green;
}

.status-Pending {
  border-top: 5px solid #f2e64b;
}

.status-Cancel {
  border-top: 5px solid #ff0000;
}

.rows_product {
  display: flex;
}

.row_product {
  white-space: nowrap;
}

.user-gols{
  color: #d47f46;
}

.user-client{
  color: #0b1d2d;
}
</style>



// WEBPACK FOOTER //
// src/components/CsIssue_Card.vue